<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
  >
    <BannerNotification />
    <ImageSliderCreatePageHeader
      :handleCreate="handleCreateSlider"
      :title="componentName"
    />
    <ImageSliderCreatePageForm
      :formData="formData"
      @update:formData="handleUpdateFormData"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import ImageSliderCreatePageHeader from "@/components/ComponentModule/ImageSliderComponent/ImageSliderCreatePageHeader";
import ImageSliderCreatePageForm from "@/components/ComponentModule/ImageSliderComponent/ImageSliderCreatePageForm";

export default {
  name: "ImageSliderCreatePage",
  components: {
    ImageSliderCreatePageHeader,
    ImageSliderCreatePageForm,
    BannerNotification
  },
  data() {
    return {
      formData: {
        slider: {
          attributes: {
            slides: []
          },
          instance_name: ""
        }
      }
    };
  },
  props: {
    componentId: {
      type: String,
      required: true
    }
  },
  mounted() {
    // fetch the abi image slider attributes
    this.$store.dispatch(Actions.FETCH_COMPONENT_ATTRIBUTES, {
      region: this.getRegion,
      componentId: this.$route.params.compId
    });
    // fetch the abi image slide attributes for slide panel
    this.$store.dispatch(Actions.FETCH_SLIDE_INSTANCE, {
      region: this.getRegion,
      componentId: this.getComponentId("abi_image_slide")
    });
    // fetch the abi image slide instances for select box
    this.$store.dispatch(Actions.FETCH_SLIDE_ATTRIBUTES, {
      region: this.getRegion,
      componentId: this.getComponentId("abi_image_slide")
    });
  },
  computed: {
    componentName() {
      if (
        this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        )
      ) {
        return this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        ).name;
      } else {
        return "";
      }
    },
    ...mapGetters(["getAllComponent", "getRegion", "currentUser"])
  },
  methods: {
    handleCreateSlider() {
      this.$store
        .dispatch(Actions.CREATE_SLIDER_INSTANCE, {
          region: this.getRegion,
          formData: this.formData,
          user: this.currentUser.email,
          currentUrl: window.location.href,
          componentId: this.getComponentId("abi_image_slider")
        })
        .then(() => {
          this.$router.push(`/component/${this.$route.params.compId}`);
        });
    },
    handleUpdateFormData(val) {
      this.formData = val;
    },
    getComponentId(name) {
      const foundItem = this.getAllComponent.find((item) => item.name === name);
      if (foundItem) {
        return foundItem.id;
      } else {
        return null;
      }
    }
  }
};
</script>
